import { render, staticRenderFns } from "./OrderControl.vue?vue&type=template&id=d37f71bc&scoped=true"
import script from "./OrderControl.vue?vue&type=script&lang=js"
export * from "./OrderControl.vue?vue&type=script&lang=js"
import style0 from "./OrderControl.vue?vue&type=style&index=0&id=d37f71bc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37f71bc",
  null
  
)

export default component.exports